import { createContext, useContext } from 'react';

interface UserSession {
  sessionId: string;
  regionId: string;
  email: string;
  accountName: string;
  multipleAccounts: boolean;
  theme: string;
  culture: string;
  timeZone: string;
}

const GlobalStateContext = createContext<{
  userSession?: UserSession;
  version?: string;
}>({});

const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  return context;
};

export { GlobalStateContext, useGlobalState };
export type { UserSession };
